import { useEffect, useState } from 'react'
import { Grid, Typography, Button } from '@material-ui/core'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'

import { withStyles } from '@material-ui/core/styles'
import styles from '../CallLogs/dateFieldStyles'

import { apiUrl } from '../../../../../ui-utils/apiConfig'
import { httpRequest } from '../../../../../ui-utils/api'

import exportFromJSON from 'export-from-json'

const AdminReport = ({ classes, dispatch, callLogs: updateCallLogs }) => {

    const [fromDate, setFromDate] = useState(null)
    const [toDate, setToDate] = useState(null)

    const [callLogs, setCallLogs] = useState([])
    const [callCount, setCallCount] = useState(0)

    const [incomingCount, setIncomingCount] = useState([])
    const [outgoingCount, setOutgoingCount] = useState([])

    const [all, setAll] = useState(false)
    const [inBoundToggle, setInBoundToggle] = useState(false)
    const [outBoundToggle, setOutBoundToggle] = useState(false)

    const handleFromDate = (newValue) => {
        setFromDate(dayjs(newValue).format('YYYY-MM-DD'))
    }

    const handleToDate = (newValue) => {
        setToDate(dayjs(newValue).format('YYYY-MM-DD'))
    }

    const fetchCallLogs = async (fromDate, toDate) => {
        const initialFromDate = fromDate === null ? dayjs().format('YYYY-MM-DD') : fromDate;
        const initialToDate = toDate === null ? dayjs().format('YYYY-MM-DD') : toDate;
        try {
            const callLogsResult = await httpRequest({
                endPoint: `${apiUrl.adminRawDumpReport}/${initialFromDate}/${initialToDate}`,
                method: "get",
                instance: "instanceOne",
            })

            if (callLogsResult.success) {
                dispatch({
                    type: 'SET_CALL_LOGS',
                    payload: callLogsResult.data.sort((a, b) => new Date(b.call_datetime) - new Date(a.call_datetime))
                })

                if (callLogsResult.data.length > 0) {
                    setAll(true)
                }

                setCallLogs(callLogsResult.data)
                setCallCount(callLogsResult.data_count)
                setIncomingCount(callLogsResult.data.filter(item => item.call_direction === 'Inbound'))
                setOutgoingCount(callLogsResult.data.filter(item => item.call_direction === 'Outbound'))
            }
            else {
                console.log('Error in Admin Report API', callLogsResult)
            }

        } catch (error) {
            console.log('Error in Admin Report API', error)
        }
    }

    useEffect(() => {
        fetchCallLogs(fromDate, toDate)
    }, [])

    const handleCallLogsSubmit = async (e) => {
        e.preventDefault();
        setInBoundToggle(false)
        setOutBoundToggle(false)
        fetchCallLogs(fromDate, toDate)
    }

    const handleAll = () => {
        setAll(!all)
        setInBoundToggle(false)
        setOutBoundToggle(false)

        dispatch({
            type: 'SET_CALL_LOGS',
            payload: callLogs
        })
    }

    const handleInBound = () => {
        setInBoundToggle(!inBoundToggle)
        setOutBoundToggle(false)
        setAll(false)
        const inBoundCall = callLogs.filter(ele => ele.call_direction === "Inbound")

        dispatch({
            type: 'SET_CALL_LOGS',
            payload: inBoundCall
        })

        if (inBoundToggle) {
            dispatch({
                type: 'SET_CALL_LOGS',
                payload: callLogs
            })
        }
    }

    const handleOutBound = () => {
        setOutBoundToggle(!outBoundToggle)
        setInBoundToggle(false)
        setAll(false)
        const outBoundCall = callLogs.filter(ele => ele.call_direction === "Outbound")

        dispatch({
            type: 'SET_CALL_LOGS',
            payload: outBoundCall
        })

        if (outBoundToggle) {
            dispatch({
                type: 'SET_CALL_LOGS',
                payload: callLogs
            })
        }
    }

    const handleDownloadCsv = () => {
        const header = ['Date&Time', 'Agent ID', 'Agent Name', 'Duration (Secs)', 'Bill (Secs)', 'Customer Number', 'Customer Name', 'Customer ID', 'Customer Email', 'Status', 'Call Direction', 'Call state', 'Call Description', 'Comments', 'Pending By', 'State', 'City', 'Created By', 'Created On', 'Updated By', 'Updated On', 'Follow Up Date/Time']

        const sortedCallLogs = updateCallLogs.sort((a, b) => {
            return new Date(a.calldatetime) - new Date(b.calldatetime)
        })

        const data = sortedCallLogs.map(item => {
            // new column in excel - srini - 28/11/24
            let parsedOther

            if (item.call_form && item.call_form.other) {
                parsedOther = JSON.parse(item.call_form.other)
            } else {
                parsedOther = {}
            }

            return {
                [header[0]]: `${item.calldatetime?.split(' ')[0]} - ${item.calldatetime?.split(' ')[1]?.split('.')[0]}`,
                [header[1]]: `${item.agentid}`,
                [header[2]]: `${item.name}`, 
                [header[3]]: `${item.duration.toString()}`, 
                [header[4]]: `${item.billingsec.toString()}`,
                [header[5]]: `${item.client_number}`,
                [header[6]]: item.call_form?.name ? item.call_form?.name : '-',
                [header[7]]: parsedOther.clientId ? parsedOther.clientId : '-',
                [header[8]]: parsedOther.custEmail ? parsedOther.custEmail : '-',
                [header[9]]: item.call_form?.status ? item.call_form.status : '-',
                [header[10]]: item.call_direction ? item.call_direction : '-',
                [header[11]]: item.call_status === 'Unknown State' ? 'UnAnswered' : item.call_status,
                [header[12]]: item.call_form?.call_description ? item.call_form.call_description : '-',
                [header[13]]: item.call_form?.comment ? item.call_form.comment : '-',
                [header[14]]: item.call_form?.pendingby ? item.call_form.pendingby : '-',
                [header[15]]: item.call_form?.state ? item.call_form.state : '-',
                [header[16]]: item.call_form?.state ? item.call_form.city : '-',
                [header[17]]: item.call_form?.createdby ? item.call_form.createdby : '-',
                [header[18]]: item.call_form?.createdon ? item.call_form.createdon : '-',
                [header[19]]: item.call_form?.updatedby ? item.call_form.updatedby : '-',
                [header[20]]: item.call_form?.updatedon ? item.call_form.updatedon : '-',
                [header[21]]: `${item.call_form?.followup_date ? item.call_form.followup_date : '-'} ${item.call_form?.followup_time ? item.call_form.followup_time : '-'}`
            }
        })

        const fileName = 'Admin Report' // srini - 21/11/24
        const exportType = exportFromJSON.types.csv
        exportFromJSON({data, fileName, exportType})
    }

    return (
        <Grid>
            <form className={classes.callLogDateField}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <span className={classes.datePickerWrapper}>
                        <DatePicker
                            label="From"
                            format="DD-MM-YYYY"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ className: classes.input }}
                            className={classes.datePicker}
                            value={fromDate}
                            onChange={(newValue) => { handleFromDate(newValue) }}
                        />
                    </span>
                    <span className={classes.datePickerWrapper}>
                        <DatePicker
                            label="To"
                            format="DD-MM-YYYY"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ className: classes.input }}
                            className={classes.datePicker}
                            value={toDate}
                            onChange={(newValue) => { handleToDate(newValue) }}
                        />
                    </span>
                </LocalizationProvider>

                <Button
                    type='submit'
                    style={{
                        width: '100px',
                        height: '34px',
                        margin: '10px 0 0 5px',
                        color: '#fff',
                        backgroundColor: '#F44748',
                        fontFamily: 'cardiuma-regular',
                        fontSize: '11px',
                        fontStyle: 'normal'
                    }}
                    onClick={(e) => handleCallLogsSubmit(e)}
                >
                    Submit
                </Button>

                <Typography className={classes.callInfo}>
                    Call count - {callCount}
                </Typography>


                <Typography className={classes.callInfo}>
                    Incoming - {incomingCount?.length}
                </Typography>

                <Typography className={classes.callInfo}>
                    Outgoing - {outgoingCount?.length}
                </Typography>
            </form>

            {/* code updated - srini - 21/11/24 */}
            <Grid container alignContent='flex-end'>
                <Grid item xs={10}>
                    <Button style={{
                        width: '100px',
                        height: '24px',
                        margin: '15px 0 0 10px',
                        color: '#F3D45E',
                        backgroundColor: all ? 'white' : '#131E2E',
                        fontFamily: 'cardiuma-regular',
                        fontSize: '13px',
                        fontStyle: 'normal',
                        fontWeight: 'bold',
                        borderRadius: '10px',
                        textTransform: 'none'
                    }}
                        onClick={handleAll}
                    >All</Button>

                    <Button style={{
                        width: '100px',
                        height: '24px',
                        margin: '15px 0 0 10px',
                        color: '#ff8c00',
                        backgroundColor: inBoundToggle ? 'white' : '#131E2E',
                        fontFamily: 'cardiuma-regular',
                        fontSize: '13px',
                        fontStyle: 'normal',
                        fontWeight: 'bold',
                        borderRadius: '10px',
                        textTransform: 'none'

                    }}
                        onClick={handleInBound}
                    >In Bound</Button>

                    <Button style={{
                        width: '100px',
                        height: '24px',
                        margin: '15px 0 0 10px',
                        color: '#00FA9A',
                        backgroundColor: outBoundToggle ? 'white' : '#131E2E',
                        fontFamily: 'cardiuma-regular',
                        fontSize: '13px',
                        fontStyle: 'normal',
                        fontWeight: 'bold',
                        borderRadius: '10px',
                        textTransform: 'none'
                    }}
                        onClick={handleOutBound}
                    >Out Bound</Button>
                </Grid>

                <Grid item xs={2} style={{ display: 'flex', justifyContent: 'flex-end' }} >
                    <Button
                        style={{
                            color: "#F3D45E",
                            textDecoration: "underline",
                            fontFamily: 'cardiuma-regular',
                            fontSize: '13px',
                            fontStyle: 'normal',
                            fontWeight: 'bold',
                        }}
                        onClick={handleDownloadCsv}
                    >
                        Download CSV
                    </Button>
                </Grid>
            </Grid>  
        </Grid>
    )
}

export default withStyles(styles)(AdminReport)